import { __ } from '@wordpress/i18n';
import {  MediaUploadCheck ,MediaPlaceholder } from '@wordpress/block-editor';
import {image} from '@wordpress/icons';

const ALLOWED_MEDIA_TYPES = [ 'image' ];

const VayuBlocksImage = (props) =>{
    const { colorPanel, attributeKey, onChange} = props;
    const index = colorPanel.findIndex(item => item?.key === attributeKey);
    const colorData = colorPanel[index];

    const handelImageUrl = (value) =>{
        onChange(attributeKey,value);
    }

    const containerStyle = {
        display: "flex",
        justifyItems: "center",
        alignItems: "center",
        gap: "4px"
    };
          
    return (
        <div style={containerStyle}>
            <img  src={
                    colorData?.value || 
                    "https://cdn-icons-png.flaticon.com/512/2956/2956800.png"
                } 
                style={{
                    borderRadius: "100%",
                    width: "20px",
                    height: "20px",
                    marginLeft: "10px",
                   ...(colorData?.value && {
                        border: "1px solid #c9c9c9",
                        backgroundColor: "#e5e5e5",
                    }),
              }}  
            />
   
            <div>{colorData?.label}</div> 

            <div className="vayu-block-imagemedia">
                <MediaUploadCheck>
                    <MediaPlaceholder
                        icon={image}
                        labels={{
                            title: __('Background Image', 'vayu-blocks'),
                            name: __('an image', 'vayu-blocks')
                        }}
                        onSelect={(media) => {
                            media?.id && handelImageUrl(media.url);
                        }} 
                        onSelectURL={(url) =>  handelImageUrl(url)}                                                            
                        accept="image/*"
                        allowedTypes={ALLOWED_MEDIA_TYPES}
                    />
                </MediaUploadCheck>
            </div>
        </div>  
    )}

export default VayuBlocksImage; 